<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="favorite_bank_account_headers"
          :headers-length="6"
          :items="favs_list"
          class="elevation-0 mt-2 mb-2 mx-3 light-regular-font"
          :no-data-text="i18n('Você não adicionou nenhuma conta aos seus favoritos')"
          :loading="loading"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.owner_name }}</td>
            <td class="text-xs-center">{{ props.item.currency }}</td>
            <td class="text-xs-center">{{ flowType(props.item.flow_type) }}</td>
            <td class="text-xs-center">{{ props.item.credit_transactions || '0' }} / {{ props.item.credit_value || '0.00' }}</td>
            <td class="text-xs-center">{{ props.item.debit_transactions || '0' }} / {{ props.item.debit_value || '0.00' }}</td>
            <td class="text-xs-center">{{ props.item.balance || '0.00' }}</td>
            <td class="text-xs-center">
              <v-icon small @click="removeAccountFromFavorites(props.item.id)" style="max-width: 35px;">clear</v-icon>
            </td>
          </template>
        </v-data-table>
        <v-snackbar
          v-model="snackbar_show"
          :color="snackbar_color"
          :timeout="3000"
        >
          {{snackbar_text}}
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  name: 'FavoriteBankAccounts',
  data() {
    return {
      favs_list: [],
      loading: false,
      snackbar_text: '',
      snackbar_show: false,
      snackbar_color: 'blue',
      download_dialog: false,
      selectedBankAccount: {},
      favorite_bank_account_headers: [
        { text: this.i18n('ID'), value: 'id', align: 'left', sortable: false },
        { text: this.i18n('Parceiro'), value: 'owner_name', align: 'center', sortable: true },
        { text: this.i18n('Moeda'), value: 'currency', align: 'center', sortable: true },
        { text: this.i18n('Fluxo'), value: 'flow_type', align: 'center', sortable: true },
        { text: this.i18n('Créditos (transações/total)'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Débitos (transações/total)'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Saldo'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Rem.'), value: 'balance', align: 'center', sortable: false },
      ]
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    localeCurrency(value, currency) {
      return this.$root.localeCurrency(value, currency)
    },
    loadFavoriteAccounts() {
      this.loading = true
      
      let successCallbackFor = () => {
        return function(response) {
          if (response.body.data) {
            this.favs_list = response.body.data
            this.loadBalances()
          } else {
            console.log(response)
          }
          this.loading = false
        }
      }

      let errorCallbackFor = () => {
        return function(response) {
          this.loading = false
          console.log(response)
        }
      }

      const token = this.$cookies.get('api_token')
      const url = this.$root.urls.admin__user_favorites
      this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackFor(), errorCallbackFor())
    },
    removeAccountFromFavorites(bank_account_id) {
      let successCallback = () => {
        this.snackbar_show = true
        return function(response) {
          if (response.body.data) {
            this.favs_list.splice(this.favs_list.findIndex(el => el.id === bank_account_id), 1)
            this.snackbar_text = 'Conta excluída da lista.'
            this.snackbar_color = 'blue'
          } else {
            console.log(response)
          }
        }
      }

      let errorCallback = () => {
        return function() {
          this.snackbar_color = 'red'
          this.snackbar_text = 'Erro. Provavelmente a conta já foi excluída'
        }
      }

      const url = `${this.$root.urls.admin__user_favorites}${bank_account_id}`
      const token = this.$cookies.get('api_token')
      this.$http.delete(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback(), errorCallback())
    },
    loadBalances() {
      let successCallbackFor = (context) => {
        return function(response) {
          if (response.body.data) {
            const index = context.fav_bank_accounts.findIndex(el => el.bank_account_id === context.id)
            let bank_account = context.fav_bank_accounts[index].bank_account
            bank_account.balance = context.localeCurrency(response.body.data.balance, bank_account.currency)
            bank_account.credit_transactions = response.body.data.credit_transactions
            bank_account.debit_transactions = response.body.data.debit_transactions
            bank_account.credit_value = context.localeCurrency(response.body.data.credit_value, bank_account.currency)
            bank_account.debit_value = context.localeCurrency(response.body.data.debit_value, bank_account.currency)
            context.fav_bank_accounts.splice(index, 1, bank_account)
          } else {
            console.log(response)
          }
          this.loading = false
        }
      }

      let errorCallbackFor = () => {
        return function(response) {
          console.log(response)
          this.loading = false
        }
      }

      const token = this.$cookies.get('api_token')
      const fav_bank_accounts = this.favs_list
      const localeCurrency = this.localeCurrency

      fav_bank_accounts.forEach(fav => {
        const url = `${this.$root.urls.admin__bank_accounts_new}${fav.bank_account_id}/balance`
        const id = fav.bank_account_id
        const context = {id, fav_bank_accounts, localeCurrency}
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackFor(context), errorCallbackFor())
      })
    },
    flowType(value) {
      if (value == 'cash_in') return this.i18n('entrada')
      if (value == 'cash_out') return this.i18n('saída')
      return this.i18n('entrada / saída')
    }
  },
  mounted() {
    this.loadFavoriteAccounts()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FavoriteBankAccounts.vue